import { Vue, i18n } from "Components/vue"

import 'Components/dpd-parcelshop'
import 'Components/zasielkovna'

const lang = document.querySelector('html').getAttribute('lang')

let updateObjednavkyTimeout = false;
let updateObjednavkyRequest = false;
let modalAvailabilityTexts;

import(`../locale/${lang}.json`).then((module) => {
    modalAvailabilityTexts = module.ModalAvailability
})

if (document.querySelector('#gls-parcelshop-map-pickup-el')) {
    import('VueComponents/GlsParcelshopPickupMap.vue').then((module) => {
        window.$_glsParcelshopPickupMap = new Vue({
            i18n,
            render: h => h(module.default)
        }).$mount("#gls-parcelshop-map-pickup-el");
    })
}

window.updateObjednavky = () => {
    const $form = $(".js-form-cart-modules");

    if (updateObjednavkyTimeout) {
        clearTimeout(updateObjednavkyTimeout);
    }

    if (updateObjednavkyRequest) {
        updateObjednavkyRequest.abort();
    }

    updateObjednavkyTimeout = setTimeout(() => {
        updateObjednavkyRequest = $.post($form.data('update-action'), $form.serialize(), function (data) {
            let recapTotals = Eshop.options.pricesWithVat ? data.totals.total : data.totals.subtotal

            Cart.updates.totals(data.totals)

            for (const type of ['payment', 'shipping']) {
                const isSelected = $(`input[name="${type}_id"]:checked`).length > 0
                const value = data.totals[type]
                const $holder = $(`.js-cart-recap-${type}-holder`)
                const $text = $(`.js-cart-recap-${type}-text`)
                const $valueEl = $(`.js-cart-recap-${type}`)

                $holder.toggleClass('hidden', !isSelected)

                if (isSelected) {
                    const name = $(`input[name="${type}_id"]:checked`).data('name').toString().trim()
                    $text.text(`(${name})`)
                }

                if (value) {
                    $valueEl.removeClass('is-green').html(Format.price(value))
                } else {
                    $valueEl.html($valueEl.data('free'))
                    $valueEl.addClass('is-green')
                }

                recapTotals -= value
            }

            recapTotals -= data.totals.discount
            recapTotals -= data.totals.packing_deposit

            $('.js-recap-totals').html(Format.price(recapTotals))
        }, "json");

        updateObjednavkyTimeout = false;
    }, 200);
}

function toggleDisabledShippingModuleInputs() {
    $('input[name="shipping_id"]').each(function() {
        const isChecked = $(this).is(':checked');
        for (const inputName of ['branch_id', 'shipping_module_id', 'shipping_name', 'shipping_address', 'shipping_post_code', 'shipping_city', 'shipping_phone']) {
            $(this)
                .closest('.js-shipping-modules-item')
                .find('input[name="' + inputName + '"]')
                .attr('disabled', !isChecked);
        }
    });
}

$(function () {
    $('input[name="shipping_id"]').on('change', function () {
        toggleDisabledShippingModuleInputs();
    });

    toggleDisabledShippingModuleInputs();
});